import { useState } from '#imports'

import * as amplitude from './amplitude/context'
import * as braze from './braze'
import * as googleTagManager from './google-tag-manager/context'
import * as stagingContext from './google-tag-manager/events/staging/context'
import * as noodle from './noodle/context'
import type { ContextData, UserContext } from './types'

// Tracks whether a user identity has already been identified (logged customer,
// merchant, staff or guest).
const IDENTIFIED_USER_STATE_KEY = 'tracking-identified-user'

function identifiedUserState() {
  return useState<boolean>(IDENTIFIED_USER_STATE_KEY, () => false)
}

export function hasIdentifiedUser() {
  return identifiedUserState().value
}

export function setUserContext(userContext: UserContext) {
  identifiedUserState().value = true

  amplitude.setUserContext(userContext)
  // bmUserContext event (still used by other tracking providers)
  googleTagManager.setUserContext(userContext)
  noodle.setUserContext(userContext)
  braze.setUserContext({})
  stagingContext.setUserContext(userContext)
}

export function setAnonymousUserDataContext() {
  stagingContext.setAnonymousUserContext()
}

export function addUserContext(context: Record<string, string>) {
  amplitude.addUserContext(context)
}

export function setCrmId(crmId: string) {
  braze.setUserContext({ crmId })
}

export function setContext(context: ContextData) {
  googleTagManager.setContext(context)
  noodle.setContext(context)
  amplitude.setContext(context)
}
